import { FC } from 'react';
import { Navigate, RouteObject } from 'react-router';
import { useRoutes } from 'react-router-dom';
import BodyShape from '../pages/bodyshape';
import FittingTypes from '../pages/fittingtype';
import CategoryPage from '../pages/category';
import LayoutPage from '../pages/layout';
import LoginPage from '../pages/login';
import NotFoundPage from '../pages/notfound';
import UserPage from '../pages/users';
import FittingSize from '../pages/fittingSize';
import BodySize  from '../pages/bodySize';
import DashboardPage from '../pages/dashboard';
import DataVersion from '../pages/dataVersion';
import ProductType from '../pages/ProductType'
import { PrivateRoute } from '../pages/PrivateRoute';
import UpdateSetting from '../pages/UpdateSetting';
import NutShapePage from '../pages/NutShape';
import NutMaterialPage from '../pages/NutMaterial';
import NutPage from '../pages/Nut';
import OrificeSizePage from '../pages/orificeSize';
import ConnectionConversionPage from '../pages/connectionConversion';

const routeList: RouteObject[] = [

    {
        path: '/login',
        element: <LoginPage />
    },
    {
        path: '/dashboard',
        element: <DashboardPage />,
    },
    {
        path: '/',
        element: <PrivateRoute><LayoutPage /></PrivateRoute>,
        children: [
            {
                path: '/users',
                element: <PrivateRoute><UserPage /></PrivateRoute>,
            },
            {
                path: '/category',
                element: <PrivateRoute><CategoryPage /></PrivateRoute>,
            },
            {
                path: '/bodyshape',
                element: <PrivateRoute><BodyShape /></PrivateRoute>,
            },
            {
                path: '/bodysize',
                element: <BodySize/>,
            },
            {
                path: '/fittingtype',
                element: <PrivateRoute><FittingTypes /></PrivateRoute>,
            },
            {
                path: '/fittingSize',
                element: <PrivateRoute><FittingSize /></PrivateRoute>,
            },
            {
                path: '/dataVersion',
                element: <PrivateRoute><DataVersion /></PrivateRoute>,
            },
            {
                path: '/productType',
                element: <PrivateRoute><ProductType /></PrivateRoute>,
            },
            {
                path: '/updateSetting',
                element: <PrivateRoute><UpdateSetting /></PrivateRoute>,
            },
            {
                path: '/nutShape',
                element: <PrivateRoute><NutShapePage /></PrivateRoute>,
            },
            {
                path: '/nutMaterial',
                element: <PrivateRoute><NutMaterialPage /></PrivateRoute>,
            },
            {
                path: '/nut',
                element: <PrivateRoute><NutPage /></PrivateRoute>,
            },
            {
                path: '/orificeSize',
                element: <PrivateRoute><OrificeSizePage /></PrivateRoute>,
            },
            {
                path: '/connectionConversion',
                element: <PrivateRoute><ConnectionConversionPage /></PrivateRoute>,
            },
            {
                path: '*',
                element: <NotFoundPage />,
            },
            {
                path: '/aassdd',
                element: <NotFoundPage />,
            }
        ]
    }

];

const RenderRouter: FC = () => {
    const element = useRoutes(routeList);
    return element;
};

export default RenderRouter;